const cartas = {
    new: {
        es: 'Menú',
        cat: '',
        pdf: './pdfs/CartaJulio2023.pdf'
    },
}

export default cartas